export const ErrorModel = {
  errorCode: 0,
  errorMessage: "",
};



// WEBPACK FOOTER //
// ./src/modules/ErrorManage/model.js